import { render } from "./CalculaterMainPage.vue?vue&type=template&id=0ba6fd96&scoped=true"
import script from "./CalculaterMainPage.vue?vue&type=script&lang=js"
export * from "./CalculaterMainPage.vue?vue&type=script&lang=js"

import "./CalculaterMainPage.vue?vue&type=style&index=0&id=0ba6fd96&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba6fd96"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
